import { render } from "./Profiling.vue?vue&type=template&id=1845e13f"
import script from "./Profiling.vue?vue&type=script&lang=js"
export * from "./Profiling.vue?vue&type=script&lang=js"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__